import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-screen" }
const _hoisted_2 = { class: "simplebar flex w-full h-full overflow-y-auto" }
const _hoisted_3 = { class: "flex flex-1 flex-col justify-start px-4 py-12 sm:px-6 lg:flex-none lg:px-12 xl:px-24 h-full relative" }
const _hoisted_4 = { class: "mx-auto w-full max-w-sm lg:w-96 flex flex-col" }
const _hoisted_5 = { class: "mt-5 text-center text-sm text-gray-400 w-full bg-white p-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle" }, "Your connection is protected by SSL", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sticky left-0 top-0 hidden w-0 h-screen flex-1 lg:block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute inset-0 h-full w-full object-cover",
    src: "https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80",
    alt: ""
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenproxNotification = _resolveComponent("GenproxNotification")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Lock = _resolveComponent("Lock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GenproxNotification),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Lock, { class: "w-6 h-6 ml-2 inline-block align-middle" })
        ])
      ]),
      _hoisted_7
    ])
  ]))
}